import { types, Instance } from 'mobx-state-tree';
const { model, string, number, identifierNumber } = types;

export const PeriodModel = model('PeriodModel', {
  id: identifierNumber,
  name: string,
  price: number,
  period: number,
  discountPrice: number,
  status: number,
});

export type IPeriodModel = Instance<typeof PeriodModel>;
